/*
  ColdCuts custom wishlist route.
  Routes the header wishlist icon to the custom ColdCuts wishlist page instead
  of opening the default Swym modal.
*/
(function () {
  function routeWishlistLinks() {
    var links = document.querySelectorAll('a[href="#swym-wishlist"], .site-header__wishlist-link a');
    links.forEach(function (link) {
      link.setAttribute('href', '/pages/wishlist');
      link.classList.add('cchw-header-wishlist-link');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', routeWishlistLinks);
  } else {
    routeWishlistLinks();
  }
})();



















/*
  ColdCuts direct wishlist add.

  The old data-swaction flow opens Swym's list-selection modal. We keep Swym as
  the data engine, but handle collection/PDP heart clicks directly through the
  JS SDK so customers get a small ColdCuts toast and the product actually saves.
*/
(function () {
  var swatReady = false;
  var swatRef = null;
  var wishlistCache = null;
  var wishlistCacheAt = 0;

  function ensureToast() {
    var toast = document.querySelector('[data-cchw-wishlist-toast]');
    if (toast) return toast;

    toast = document.createElement('div');
    toast.className = 'cchw-wishlist-toast';
    toast.setAttribute('data-cchw-wishlist-toast', '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = 'Added to wishlist';
    document.body.appendChild(toast);
    return toast;
  }

  function getHeaderBottom() {
    var selectors = [
      '.site-header',
      '#shopify-section-header',
      '.header-wrapper',
      'header[role="banner"]',
      'header'
    ];

    var bottom = 0;

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.height > 0 && rect.bottom > bottom && rect.bottom < window.innerHeight * 0.5) {
          bottom = rect.bottom;
        }
      });
    });

    return Math.max(bottom, 0);
  }

  function positionWishlistToast() {
    var toast = document.querySelector('[data-cchw-wishlist-toast]');
    if (!toast) return;

    var headerBottom = getHeaderBottom();
    var offset = window.matchMedia('(max-width: 749px)').matches ? 10 : 12;
    var top = Math.max(headerBottom + offset, 72);

    toast.style.setProperty('top', top + 'px', 'important');
    toast.style.setProperty('bottom', 'auto', 'important');
    toast.style.setProperty('left', window.matchMedia('(max-width: 749px)').matches ? '12px' : '18px', 'important');
    toast.style.setProperty('right', 'auto', 'important');
  }

  function showToast(message) {
    var toast = ensureToast();
    toast.textContent = message || 'Added to wishlist';
    positionWishlistToast();
    toast.classList.add('is-visible');

    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  function removeScrollLockClasses(el) {
    if (!el || !el.classList) return;

    Array.prototype.slice.call(el.classList).forEach(function (className) {
      if (
        className === 'swym-modal-open' ||
        className === 'swym-overlay-open' ||
        className === 'modal-open' ||
        className === 'no-scroll' ||
        className === 'overflow-hidden' ||
        className === 'swym-no-scroll' ||
        /swym/i.test(className) && /(modal|overlay|popup|open|scroll|lock)/i.test(className)
      ) {
        el.classList.remove(className);
      }
    });
  }

  function unlockPageScroll() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;

    removeScrollLockClasses(document.documentElement);
    removeScrollLockClasses(document.body);

    ['overflow', 'overflowY', 'position', 'height', 'width', 'top', 'left', 'right', 'touchAction'].forEach(function (prop) {
      document.documentElement.style[prop] = '';
      document.body.style[prop] = '';
    });

    // Swym's mobile popup can briefly leave body/html fixed or overflow-hidden.
    // Restore the customer's scroll position when clearing those locks.
    if (scrollTop > 0 && Math.abs((window.pageYOffset || 0) - scrollTop) > 2) {
      window.scrollTo(scrollLeft, scrollTop);
    }
  }

  function suppressElement(el) {
    if (!el) return;

    el.classList.add('cchw-swym-suppressed');
    el.setAttribute('aria-hidden', 'true');
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('opacity', '0', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
  }

  function suppressSwymModal() {
    document.querySelectorAll(
      '#swym-plugin, #swym-hosted-plugin, #swym-overlay, #swym-notification, #swym-notepad, .swym-modal, .swym-notification, .swym-overlay, .swym-ui-component, .swym-wishlist-context-menu, .swym-popup, .swym-modal-backdrop, .swym-notepad, .swym-auth-popup, .swym-email-popup'
    ).forEach(suppressElement);

    unlockPageScroll();
  }

  function suppressSwymModalForWindow() {
    [0, 30, 80, 160, 320, 700, 1200, 2200, 3500, 5000].forEach(function (delay) {
      window.setTimeout(suppressSwymModal, delay);
    });
  }

  function waitForSwym(callback, attempt) {
    attempt = attempt || 0;

    if (swatReady && swatRef) {
      callback(swatRef);
      return;
    }

    if (window._swat) {
      swatReady = true;
      swatRef = window._swat;
      callback(swatRef);
      return;
    }

    if (attempt < 80) {
      window.setTimeout(function () {
        waitForSwym(callback, attempt + 1);
      }, 100);
      return;
    }

    showToast('Wishlist is still loading, please try again');
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    swatReady = true;
    swatRef = swat;
  });

  function getProductFromButton(button) {
    var productId = button.getAttribute('data-product-id');
    var product = null;

    if (productId && window.SwymViewProducts) {
      product = window.SwymViewProducts[productId] || window.SwymViewProducts[String(productId)];
    }

    if (!productId && window.SwymPageData) {
      product = window.SwymPageData;
    }

    if (!product && productId && window.SwymProductVariants) {
      Object.keys(window.SwymProductVariants).some(function (key) {
        var variant = window.SwymProductVariants[key];
        if (variant && String(variant.empi) === String(productId)) {
          product = Object.assign({}, variant);
          return true;
        }
        return false;
      });
    }

    if (!product) return null;

    var variantId = product.epi || product.variantId || product.variant_id;
    if (!variantId && product.variants) {
      try {
        var variants = typeof product.variants === 'string' ? JSON.parse(product.variants) : product.variants;
        if (Array.isArray(variants) && variants[0]) {
          variantId = variants[0].id || variants[0].epi;
        }
      } catch (error) {}
    }

    if (!variantId && window.SwymProductVariants) {
      Object.keys(window.SwymProductVariants).some(function (key) {
        var variant = window.SwymProductVariants[key];
        if (variant && String(variant.empi) === String(product.empi || productId)) {
          variantId = variant.epi;
          product.pr = product.pr || variant.pr;
          product.iu = product.iu || variant.iu;
          return true;
        }
        return false;
      });
    }

    return {
      epi: Number(variantId),
      empi: Number(product.empi || product.id || productId),
      du: product.du || product.url || product.productUrl || window.location.href,
      dt: product.dt || product.title || '',
      iu: product.iu || product.image || '',
      pr: product.pr || 0
    };
  }

  function refreshWishlistCache(swat, callback) {
    var now = Date.now();

    if (wishlistCache && now - wishlistCacheAt < 1500) {
      callback(wishlistCache);
      return;
    }

    if (typeof swat.fetch === 'function') {
      swat.fetch(function (items) {
        wishlistCache = Array.isArray(items) ? items : [];
        wishlistCacheAt = Date.now();
        callback(wishlistCache);
      });
      return;
    }

    if (typeof swat.fetchWrtEventTypeET === 'function') {
      swat.fetchWrtEventTypeET(function (items) {
        wishlistCache = Array.isArray(items) ? items : [];
        wishlistCacheAt = Date.now();
        callback(wishlistCache);
      }, swat.EventTypes ? swat.EventTypes.addToWishList : 4);
      return;
    }

    callback([]);
  }

  function isAlreadyWishlisted(items, product) {
    return (items || []).some(function (item) {
      return String(item.empi) === String(product.empi) && String(item.epi) === String(product.epi);
    });
  }

  function markButtonAdded(button) {
    if (!button) return;
    button.classList.add('swym-added', 'cchw-wishlist-added');
    button.setAttribute('aria-label', 'Already in wishlist');
  }

  function addProductToWishlist(swat, product, button) {
    if (!product || !product.empi || !product.epi) {
      showToast('Could not add to wishlist');
      return;
    }

    refreshWishlistCache(swat, function (items) {
      if (isAlreadyWishlisted(items, product)) {
        markButtonAdded(button);
        showToast('Already in wishlist');
        suppressSwymModalForWindow();
        return;
      }

      if (typeof swat.addToWishList !== 'function') {
        showToast('Wishlist is still loading, please try again');
        return;
      }

      swat.addToWishList(product, function () {
        wishlistCache = null;
        markButtonAdded(button);
        showToast('Added to wishlist');
        suppressSwymModalForWindow();
      }, function () {
        showToast('Could not add to wishlist');
        suppressSwymModalForWindow();
      });
    });
  }

  function getWishlistButtonFromEvent(event) {
    if (!event || !event.target || !event.target.closest) return null;
    return event.target.closest('[data-swaction="addToWishlist"]');
  }

  function guardWishlistTouch(event) {
    var button = getWishlistButtonFromEvent(event);
    if (!button) return;

    // Stop Swym's delegated mobile touch handlers from opening/locking its popup.
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    suppressSwymModalForWindow();
  }

  function handleWishlistClick(event) {
    var button = getWishlistButtonFromEvent(event);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    if (button.getAttribute('data-cchw-wishlist-busy') === 'true') {
      suppressSwymModalForWindow();
      return;
    }

    button.setAttribute('data-cchw-wishlist-busy', 'true');
    suppressSwymModalForWindow();

    waitForSwym(function (swat) {
      var product = getProductFromButton(button);
      addProductToWishlist(swat, product, button);
      window.setTimeout(function () {
        button.removeAttribute('data-cchw-wishlist-busy');
      }, 900);
    });
  }

  ['touchstart', 'touchend', 'pointerdown', 'mousedown'].forEach(function (eventName) {
    document.addEventListener(eventName, guardWishlistTouch, true);
  });

  document.addEventListener('click', handleWishlistClick, true);

  if (window.MutationObserver) {
    var suppressScheduled = false;
    var observer = new MutationObserver(function () {
      if (suppressScheduled) return;
      suppressScheduled = true;

      window.setTimeout(function () {
        suppressScheduled = false;
        suppressSwymModal();
      }, 30);
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      childList: true,
      subtree: true
    });
  }

  window.addEventListener('resize', positionWishlistToast);
  window.addEventListener('scroll', positionWishlistToast, { passive: true });
  window.addEventListener('load', unlockPageScroll);
  document.addEventListener('visibilitychange', unlockPageScroll);
})();
